import { Box, Drawer } from '@mui/material';
import SendDrawerContent from 'components/@home/@documents/SentDocuments/SendDrawerContent';
import { SendDrawerContext } from 'components/@home/@documents/SentDocuments/SendDrawerContext';
import CloseButton from 'components/@home/drawers/CloseButton';
import React, { useContext } from 'react';

const SendDrawer = () => {
  const { isOpen, close } = useContext(SendDrawerContext);

  return (
    <Drawer anchor="right" open={isOpen} onClose={close} onClick={e => e.stopPropagation()}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flex: 1,
          maxWidth: 'calc(100vw - 40px)',
          width: { xs: '100%', md: 1280 },
          height: '100vh',
        }}
      >
        {/* Same pattern as EmployeeDrawer / AnalyticsDrawer: close column on the inner-left */}
        <Box sx={{ flexShrink: 0, pt: 2.5, pl: 2.5 }}>
          <CloseButton onClick={close} />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flex: 1,
            minWidth: 0,
            minHeight: 0,
            flexDirection: 'column',
            padding: 2.5,
            paddingLeft: 1,
          }}
        >
          <SendDrawerContent />
        </Box>
      </Box>
    </Drawer>
  );
};

export default SendDrawer;
